import { Component, OnInit, ViewChild } from "@angular/core"
import isEqual from "lodash.isequal"
import { Router } from "@angular/router";

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { UserHttpClientService } from "src/app/data/user-http-client.service"
import { UserWallet } from "src/app/models/User/user-wallet"
import { Client } from "src/app/services/API/client"
import { environment } from "src/environments/environment"
import { TranslateService } from "@ngx-translate/core"
import { LayoutService } from "src/app/services/layout.service"
import { Draft, BetweenBankTransfer } from "src/app/models/transfer/transfer"
import { TransferHub } from "src/app/services/Hub/hub.transfer.service"
import { CodeInputComponent } from "angular-code-input"
import { SetTitleService } from "src/app/services/set-title.service";
import { User } from "src/app/models/User/user";

@Component({
  templateUrl: "./transfer-mobile-ui.component.html",
  styleUrls: ["./transfer-mobile-ui.component.css"]
})

export class TransferComponent implements OnInit {
  environment: any
  showConfirmModal: boolean = false
  sidebarWidth: number
  loading: boolean = false
  wallets: UserWallet[] = []
  selectedWalletId: number = 0
  transferType: string = "" // 1 - Inside, 2 - Outside
  transferOption: string = "" // 1 - New, 2 - Saved
  drafts: Draft[] = []
  pageNumber: number = 1
  pageSize: number = 15
  totalRecords: number = 0
  beneficiaryName: string = ""
  receiverAccountId: string = ""
  receiverIban: string = ""
  amount: string = ""
  bankName: string = ""
  description: string = ""
  commisionType: string = "OUR"
  ipAddress: string = "127.0.0.1"
  deviceId: string = "EternaWebPosta"
  saveAsDraft: boolean = false
  draftTransferId: number = 0
  draftData: any = null
  bic: string = ""
  bankCountry: string = ""
  selectedCurrencyCode: string = ""
  receiverCurrencyCode: string = ""
  exchangeRate: number = 0
  confirmOtpModal: boolean = false
  operationId: string = ""
  isAuthorized: boolean

  @ViewChild("codeInput") codeInput !: CodeInputComponent

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private userService: UserHttpClientService,
    private client: Client,
    private translateService: TranslateService,
    private layoutService: LayoutService,
    private _hub: TransferHub,
    private router: Router,
    private settitleservice : SetTitleService
  ) {
    this.environment = environment
    layoutService.sidebarWidth.subscribe(data => this.sidebarWidth = data)
    if (session.isLoggedIn()) {
      this.prepareHub()
      this.subcribeHubEvent()
    }
  }

  ngOnInit() {
    this.getWallets();
    this.settitleservice.sendTitle("Transfer");
    this.userService.getUserDetails().subscribe((user: User) => {
      this.isAuthorized = user.is_authorized;
  });
  }

  private prepareHub() {
    this._hub.buildConnection()
    this._hub.startConnection()
  }

  private subcribeHubEvent() {
    this._hub.transferRetryEventEmitter.subscribe((shouldRetry: boolean) => {
      if (shouldRetry) {
        this.toastr.error(this.translateService.instant("Transfer.SomethingWrong"))
        this.loading = false
      }
    })

    this._hub.transferRejectedEventEmitter.subscribe((isRejected: boolean) => {
      if (isRejected) {
        this.toastr.error(this.translateService.instant("Transfer.TransferRejected"))
        this.closeConfirmModal()
        this.loading = false
      }

    })

    this._hub.transferSuccessEventEmitter.subscribe((isSucceed: boolean) => {
      if (isSucceed) {
        this.toastr.success(this.translateService.instant("Transfer.TransferCompleted"))
        this.router.navigateByUrl("/transfer-history")
        this.loading = false
      }
    })
  }

  onCodeChanged(event: any) {
      
  }

  async verifyOTP(otp: string) {
    if (this.loading) return

    this.loading = true

    try {
      const { operationId, transferType } = this
      const data = {
        otp,
        operationId
      }
      const url = transferType === "1"
        ? "api/transfers/transfer-money-beetwen-bank/web/verifyCode"
        : "api/transfers/transfer-money-outside-bank/web/verifyCode"
      const res: any = await this.client.post(url, data)
      if (res.remainingAttempts) throw new Error(this.translateService.instant("Transfer.RemainingAttempts", { count: res.remainingAttempts }) + `. ${res.message || ""}`)
      this.resetForm()
      this.closeConfirmOTPModal()
      this.selectedCurrencyCode = this.getSelectedWalletCurrencyCode()
      this.toastr.success(this.translateService.instant("Transfer.TransferCompleted"))
      this.router.navigateByUrl("/transfer-history")
    } catch(err) {
      let errMessage = err.message
      if (err.error) {
        const { remainingAttempts, message } = err.error
        if (message) {
          errMessage = message
        }

        if (remainingAttempts) {
          errMessage += `. ${this.translateService.instant("Transfer.RemainingAttempts", { count: remainingAttempts })}`
        } else {
          this.closeConfirmOTPModal()
        }
      }

      this.toastr.error(errMessage)
    }
    this.codeInput.reset()

    this.loading = false
  }

  async getWallets() {
    if (!this.session.isLoggedIn()) return
    
    this.loading = true

    this.userService.getUserWallets()
      .subscribe({
        next: (wallets: UserWallet[]) => {
          this.wallets = wallets
          if (wallets[0]) {
            this.selectedWalletId = wallets[0].walletId
            this.selectedCurrencyCode = wallets[0].currencyCode
          }
          this.loading = false
        },
        error: (err) => {
          this.toastr.error(err)
          this.loading = false
        }
      })
  }

  getSelectedWallet() {
    return this.wallets.find(item => item.walletId === Number(this.selectedWalletId))
  }

  getSelectedWalletCurrencyCode() {
    const selectedWallet = this.getSelectedWallet()
    return selectedWallet && selectedWallet.currencyCode || ""
  }

  setSelectedWalletId(walletId: number) {
    if (this.selectedWalletId === walletId) return
    this.selectedWalletId = walletId
    this.selectedCurrencyCode = this.getSelectedWallet().currencyCode
    if (this.transferOption == '2') {
      this.getDrafts(true)
    }
  }

  setSelectedCurrencyCode(code: string) {
    if (this.selectedCurrencyCode === code) return
    this.selectedCurrencyCode = code
    this.getRate()
  }

  setCommisionType(type: string) {
    if (this.commisionType === type) return
    this.commisionType = type
  }

  setTransferType(value: string) {
    if (this.transferType === value) return
    this.transferType = value
  }

  setTransferOption(value: string) {
    if (this.transferOption === value) return
    this.transferOption = value
    if (this.transferOption === "2") {
      this.getDrafts(true)
    }
  }

  getCurrencyCode(currencyId: number) {
    if (currencyId === 1) return "ALL"
    if (currencyId === 2) return "EUR"
    if (currencyId === 4) return "XCD"
    return ""
  }

  async getReceiverAccount() {
    try {
      if (!this.receiverAccountId) return
      const receiverAccountRes: any = await this.client.get("api/transfers/receiver_account", { accountId: this.receiverAccountId })
      const { currencyId }: any = receiverAccountRes || {}
      if (!!currencyId) {
        this.receiverCurrencyCode = this.getCurrencyCode(currencyId)
        this.selectedCurrencyCode = this.getSelectedWallet().currencyCode
        this.getRate()
      }
    } catch(err) {
      this.toastr.error(err.message)
    }
  }

  onBlurReceiverAccount() {
    if (this.transferType === '2') return
    this.getReceiverAccount()
  }

  async getRate() {
    if (this.transferType === '2') return
    const selectedWallet = this.getSelectedWallet()
    if (selectedWallet.currencyCode === this.selectedCurrencyCode) return
    this.loading = true
    try {
      const res: any = await this.client.get("api/transfers/rate", { amountcurrencycode: this.selectedCurrencyCode, sendercurrencycode: selectedWallet.currencyCode })
      this.exchangeRate = res
    } catch(err) {
      this.toastr.error(err.message)
    }
    this.loading = false
  }

  convertAmount() {
    return Number(this.amount || "0") * this.exchangeRate
  }

  async getDrafts(isRefresh: boolean = false) {
    if (isRefresh) this.pageNumber = 1

    const { currencyCode } =  this.getSelectedWallet()
    const { pageNumber, pageSize, transferType } = this

    this.loading = true

    try {
      const res: any = await this.client.get("api/transfers/drafts", { pageNumber, pageSize, transferType, currencyCode })
      this.totalRecords = res.totalRecords || 0
      this.drafts = isRefresh ? res.data : this.drafts.concat(res.data)
    } catch(err) {
      this.toastr.error(err)
    }

    this.loading = false
  }

  canLoadMore() {
    return this.drafts.length < this.totalRecords
  }

  loadMore() {
    if (this.loading || !this.canLoadMore()) return 
    ++this.pageNumber
    this.getDrafts()
  }

  resetForm() {
    this.beneficiaryName = ""
    this.receiverAccountId = ""
    this.receiverIban = ""
    this.amount = ""
    this.bankName = ""
    this.description = ""
    this.commisionType = "OUR"
    this.saveAsDraft = false
    this.draftTransferId = 0
    this.draftData = null
    this.bic = ""
    this.bankCountry = ""
    this.selectedCurrencyCode = ""
    this.receiverCurrencyCode = ""
    this.exchangeRate = 0
  }

  onClickDraft(draft: Draft) {
    this.transferOption = '1'
    this.selectedWalletId = draft.walletId
    this.draftTransferId = draft.transferId

    if (draft.transferType == 1) {
      this.receiverAccountId = `${draft.receiverAccountId}`
      this.amount = `${draft.transferAmount}`
      this.description = draft.description
      this.commisionType = draft.commisionType
      this.beneficiaryName = draft.beneficiaryName
      this.selectedCurrencyCode = draft.amountCurrencyCode,
      this.receiverCurrencyCode = draft.amountCurrencyCode
      this.draftData = {
        receiverAccountId: `${draft.receiverAccountId}`,
        amount: `${draft.transferAmount}`,
        selectedCurrencyCode: draft.amountCurrencyCode,
        description: draft.description,
        commisionType: draft.commisionType,
        senderWalletId: draft.walletId,
        beneficiaryName: draft.beneficiaryName
      }
    }

    if (draft.transferType == 2) {
      this.receiverIban = draft.iban
      this.amount = `${draft.transferAmount}`
      this.bankName = draft.bankName
      this.description = draft.description
      this.commisionType = draft.commisionType
      this.beneficiaryName = draft.beneficiaryName
      this.bic = draft.bic
      this.bankCountry = draft.bankCountry
      this.draftData = {
        receiverIban: draft.iban,
        amount: `${draft.transferAmount}`,
        amountCurrencyCode: draft.amountCurrencyCode,
        bankName: draft.bankName,
        description: draft.description,
        commisionType: draft.commisionType,
        beneficiaryName: draft.beneficiaryName,
        bic: draft.bic,
        bankCountry: draft.bankCountry,
        senderWalletId: draft.walletId
      }
    }
  }

  draftIsChanged() {
    const {
      transferType,
      draftData,
      receiverAccountId,
      receiverIban,
      amount,
      description,
      commisionType,
      bankName,
      bic,
      bankCountry,
      beneficiaryName,
      selectedCurrencyCode
    } = this
    const { walletId: senderWalletId, currencyCode: amountCurrencyCode } = this.getSelectedWallet() || {} as any

    let data: any = null
    if (transferType === "1") {
      data = {
        receiverAccountId,
        amount,
        selectedCurrencyCode,
        description,
        commisionType,
        senderWalletId,
        beneficiaryName
      }
    }

    if (transferType === "2") {
      data = {
        receiverIban,
        amount,
        amountCurrencyCode,
        bankName,
        description,
        commisionType,
        beneficiaryName,
        bic,
        bankCountry,
        senderWalletId
      }
    }

    return !isEqual(data, draftData)
  }

  async validateIban() {
    this.loading = true

    try {
      const checkIbanRes: any = await this.client.get("api/transfers/validate-iban", { iban: this.receiverIban })
      const { iban_is_valid, iband_data } = checkIbanRes
      if (!iban_is_valid) throw new Error(this.translateService.instant("Transfer.InvalidReceiverIban"))
      this.bankName = iband_data.bankName
      this.bic = iband_data.bic
    } catch(err) {
      this.toastr.error(err.message)
      this.bankName = ""
      this.bic = ""
    }

    this.loading = false
  }

  validate(notAlert: boolean = false) {
    try {
      if (!this.transferType) throw new Error(this.translateService.instant("Transfer.InvalidRequest"))
      const selectedWallet = this.getSelectedWallet()
      if (!selectedWallet.walletId || !selectedWallet.currencyCode) throw new Error(this.translateService.instant("Transfer.InvalidSenderWalletInformation"))
      if (!this.amount || Number(this.amount) <= 0) throw new Error(this.translateService.instant("Transfer.AmountGreaterThan0"))
      if (!this.beneficiaryName || !this.beneficiaryName.trim()) throw new Error(this.translateService.instant("Transfer.BeneficiaryNameEmpty"))

      if (this.transferType === "1") {
        if (!this.receiverAccountId || !this.receiverAccountId.trim()) throw new Error(this.translateService.instant("Transfer.ReceiverAccountIdEmpty"))
      }

      if (this.transferType === "2") {
        if (!this.commisionType) throw new Error(this.translateService.instant("Transfer.CommisionTypeEmpty"))
        if (!this.receiverIban || !this.receiverIban.trim()) throw new Error(this.translateService.instant("Transfer.ReceiverIbanEmpty"))
        if (!this.bankName || !this.bankName.trim()) throw new Error(this.translateService.instant("Transfer.BankNameEmpty"))
      }
      
      return true
    } catch(err) {
      !notAlert && this.toastr.error(err.message)
      return false
    }
  }

  getData(sendType: number) {
    const { 
      transferType,
      receiverAccountId,
      receiverIban,
      amount,
      bankName,
      description,
      commisionType,
      ipAddress,
      deviceId,
      saveAsDraft,
      draftTransferId,
      beneficiaryName,
      bic, 
      bankCountry,
      selectedCurrencyCode
    } = this

    const { walletId: senderWalletId, currencyCode: amountCurrencyCode } = this.getSelectedWallet() || {} as any
    let data = {}
    if (this.transferType === "1") {
      data = {
        transferType: Number(transferType),
        receiverAccountId: parseInt(receiverAccountId),
        amount: Number(amount),
        amountCurrencyCode: selectedCurrencyCode,
        description,
        commisionType,
        senderWalletId,
        ipAddress,
        deviceId,
        saveAsDraft,
        draftTransferId: this.draftIsChanged() ? draftTransferId : 0,
        beneficiaryName, 
        sendType
      } as BetweenBankTransfer
    } else {
      data = {
        transferType: Number(transferType),
        receiverIban,
        amount,
        amountCurrencyCode,
        bankName,
        description,
        commisionType,
        senderWalletId,
        ipAddress,
        deviceId,
        priority: null, // for the moment
        beneficiaryName,
        bankAccountNumber: null, // for the moment
        beneficiaryAddress: null, // for the moment
        rootingNumber: null, // for the moment
        bic,
        bankCountry,
        saveAsDraft,
        draftTransferId: this.draftIsChanged() ? draftTransferId : 0,
        sendType
      }
    }

    return data
  }

  getEndpoint = () => {
    if (this.transferType === "1") return "api/transfers/transfer-money-beetwen-bank/web"
    if (this.transferType === "2") return "api/transfers/transfer-money-outside-bank/web"
    return ""
  }

  async send(sendType: number) {
    if (this.loading) return 
    const passed = this.validate()
    if (!passed) return
    this.loading = true

    try {
      const data = this.getData(sendType)
      const res: any = await this.client.post(this.getEndpoint(), data)
      this.operationId = res
      if (sendType === 1 || sendType === 2) {
        this.openConfirmOTPModal()
        this.closeConfirmModal()
      }

      if (sendType === 3) {
        this.toastr.success(this.translateService.instant("Transfer.CheckMobileRequest"))
      }
    } catch(err) {
      this.toastr.error(err.response && err.response.data || err.message)
    }

    sendType !== 3 && (this.loading = false)
  }

  backToTransferType() {
    this.transferType = ""
  }

  backToTransferOption(isReset: boolean) {
    this.transferOption = ""
    if (isReset) {
      this.resetForm()
      this.selectedCurrencyCode = this.getSelectedWalletCurrencyCode()
    }
  }

  openConfirmModal() {
    this.showConfirmModal = true
  }

  closeConfirmModal() {
    this.showConfirmModal = false
  }

  openConfirmOTPModal() {
    this.confirmOtpModal = true
  }

  closeConfirmOTPModal() {
    this.confirmOtpModal = false
  }
}